import React, { Component } from 'react'
import { FormattedHTMLMessage } from 'react-intl';
import {Row,Col,Collapse,Well} from 'react-bootstrap';
import { trackEvent } from '../../../utils';
import { EventTag } from '../../../config/tagging';
import './styles/styles.css'

export default class Faq extends Component{
    constructor(...args){
        super(...args);
        this.state = {
            open: this.props.isOpen
        };
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick (e) {
        e.preventDefault();
        trackEvent(EventTag.helpDropdown(this.props.title), 'func');
        this.setState({open:!this.state.open});
    }

    render(){
        return (
            <div data-key={this.props.index} className={this.state.open ? 'faq active' :'faq'} id={this.props.currentId}>
                <Row className='faqItem' data-name={this.props.title} onClick={this.handleClick}>
                    <Col xs={10}><h4>{this.props.title}</h4></Col>
                    <Col xs={2} className='icon'><i className={this.state.open ? 'icon icon-chevron-up' :'icon icon-chevron-down'}></i></Col>
                </Row>
                <Collapse in={this.state.open}>
                    <div>
                        <Well>
                            <FormattedHTMLMessage id={this.props.index+"_faq_content"} defaultMessage={this.props.content} />
                        </Well>
                    </div>
                </Collapse>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/shared/Faq/components/Faq.js